import apiService from '../apiService';

let group = (function () {
    let addValidations = function () {
        $("#add-group").validate({
            ignore: "",
            errorClass: "text-danger",
            rules: {
                name: { required: true, alphanumeric: true },
            },
        });

        $("#update-remove-from-group").validate({
            ignore: "",
            errorClass: "text-danger",
            rules: {
                remove_vm_id: "required",
                move_group_id: "required",
            },
        });

        $("#update-add-to-group").validate({
            ignore: "",
            errorClass: "text-danger",
            rules: {
                add_vm_id: "required",
            },
        });
    };

    let addGroup = function () {
        //Add new group
        $(document).on("click", "#save-group", function () {
            if ($("#add-group").valid()) {
                let formData = new FormData($("#add-group")[0]);
                $.ajax({
                    url: baseUrl + "/admin/groups/store",
                    type: "POST",
                    data: formData,
                    async: false,
                    cache: false,
                    contentType: false,
                    processData: false,
                    success: function (response) {
                        $("#groupModal").modal("toggle");
                        Swal.fire({
                            title: "Success",
                            text: response.message,
                            type: "success",
                            icon: "success",
                        }).then(() => {
                            window.location.reload();
                        });
                    },
                });
            }
        });

        $(document).on("click", ".edit-group", function () {
            $("#add-group")[0].reset();
            $("#add-group").validate().resetForm();
            let id = $(this).data("id");
            $.ajax({
                url: baseUrl + "/admin/groups/edit/" + id,
                type: "GET",
                success: function (response) {
                    if (response.group) {
                        $("#groupModal").modal("toggle");
                        $("#group_id").val(response.group.id);
                        $("#name").val(response.group.name);
                    }
                },
            });
        });

        $(document).on("click", ".delete-groups", function () {
            let vmCount = $(this).data("vmscount");
            let groupName = $(this).data("grpname");
            if (vmCount > 0) {
                Swal.fire({
                    icon: "warning",
                    title: "Warning!",
                    text: "You can`t delete group, Group has assign virtual machine!",
                });
            } else {
                Swal.fire({
                    title: "Are you sure you want to delete group " + groupName + "?",
                    text: "You want to delete this group",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "Yes, Delete it!",
                }).then((result) => {
                    if (result.isConfirmed) {
                        let id = $(this).data("id");
                        $.ajax({
                            url: baseUrl + "/admin/groups/delete/" + id,
                            type: "DELETE",
                            success: function (response) {
                                Swal.fire({
                                    title: "Success",
                                    text: response.message,
                                    type: "success",
                                    icon: "success",
                                }).then(() => {
                                    window.location.reload();
                                });
                            },
                        });
                    }
                });
            }
        });

        //Open Modal pop up
        $(document).on("click", "#add-new-group", function () {
            $("#groupModal").modal("toggle");
            $("#add-group")[0].reset();
            $("#add-group").validate().resetForm();
            $("#group_id").val("");
        });

        //Open Modal pop up
        $(document).on("click", ".add-to-group", function () {
            $("#update-add-to-group")[0].reset();
            $("#update-add-to-group").validate().resetForm();
            let groupId = $(this).data("id");
            let userId = $(this).data("userid");
            let siteId = $(this).data("siteid");
            
            $("#add_vm_id").html('<option value="">Select VM</option>');
            $("#add-to-group-modal").modal("toggle");
            let groupName = $(this).data("grpname");
            $("#modal-add-group-name").text(groupName);
            $.ajax({
                url: "/admin/group-vms/group/" + groupId + '/user/' + userId + '/site/' + siteId,
                type: "GET",
                success: function (response) {
                    let html = "";
                    $.each(response.virtualMachine, function (i, v) {
                        html += '<option value="' + v["id"] + '">' + v["name"] + "</option>";
                    });

                    $("#add_vm_id").append(html);
                    $("#vm_group_id").val(groupId);
                },
            });
        });

        //Open Modal pop up

        $(document).on("click", ".remove-from-group", function () {
            $("#update-remove-from-group")[0].reset();
            $("#update-remove-from-group").validate().resetForm();
            $("#move_group_id_div").addClass("d-none");
            $("#remove_vm_id").html('<option value="">Select VMs</option>');
            let groupId = $(this).data("id");
            let userId = $(this).data("userid");
            let siteId = $(this).data("siteid");
            $("#rvm_group_user_id").val(userId);

            let groupName = $(this).data("grpname");
            $("#modal-remove-group-name").text(groupName);
            $("#remove-from-group-modal").modal("toggle");
            $.ajax({
                url: baseUrl + "/admin/vm-list/group/" + groupId + '/user/' + userId + '/site/' + siteId,
                type: "GET",
                success: function (response) {
                    let html = "";
                    $.each(response.virtualMachine, function (i, v) {
                        html += '<option value="' + v["id"] + '">' + v["name"] + "</option>";
                    });

                    $("#remove_vm_id").append(html);
                    $("#rvm_group_id").val(groupId);
                },
            });
        });


        $(document).on("click", "#remove_vm_id", function () {
            if ($(this).val() == "") {
                $("#move_group_id_div").addClass("d-none");
            } else {
                let groupId = $("#rvm_group_id").val();
                let userId = $("#rvm_group_user_id").val();
                $.ajax({
                    url: baseUrl + "/admin/group-list/group/" + groupId + "/user/" + userId,
                    type: "GET",
                    success: function (response) {
                        let html = '<option value="">Select Group</option><option value="custom">Create Custom Group</option>';
                        $.each(response.groups, function (i, v) {
                            html += '<option value="' + v["id"] + '">' + v["name"] + "</option>";
                        });

                        $("#move_group_id").html(html);
                        $("#move_group_id_div").removeClass("d-none");
                    },
                });
            }
        });

        $(document).on("click", "#move_group_id", function () {
            if ($("#move_group_id").val() == "custom") {
                let userId = $('#rvm_group_user_id').val();
                addCustomGroup("remove-from-group-modal", userId);
                $("#move_group_id").val("");
            }
        });

        $(document).on("click", "#groups_id", function () {
            if ($("#groups_id").val() == "custom") {
                let userId = $('#user_id').val();
                addCustomGroup("virtualMachineModal", userId);
            }
        });

        let addCustomGroup = (modalId, userId) => {
            console.log(userId);
            $("#" + modalId).modal("toggle");
            Swal.fire({
                title: "Add Custom Group",
                // html: `<input type="text" id="group_name" class="form-control" placeholder="Enter Custom Group Name">`,
                input: 'text',
                inputAttributes: {
                    input: 'text',
                    placeholder: 'Enter custom group name',
                },
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Add Group",
                customClass: {
                    validationMessage: "my-validation-message",
                    input: 'form-control',
                },
                preConfirm: (value) => {
                    let regExp = /^[a-zA-Z0-9_ -]*$/;
                    if (value.trim() == "") {
                        Swal.showValidationMessage('Group name is required');
                    }
                    if (!regExp.test(value)) {
                        Swal.showValidationMessage('Please enter valid string!');
                    }
                },
            }).then((result) => {
                if (result.isConfirmed) {
                    $(".loading").removeClass("d-none");
                    $.ajax({
                        url: baseUrl + "/admin/groups/store",
                        type: "POST",
                        dataType: "JSON",
                        data: { name: result.value, user_id: userId },
                        success: function (response) {
                            $(".loading").addClass("d-none");
                            if (response.status == "success") {
                                let html = '<option value="' + response.data.group_id + '" selected>' + response.data.group_name + "</option>";
                                $("#groups_id").append(html);
                                $("#groups_id").val(response.data.group_id);
                                $("#move_group_id").append(html);
                                $("#move_group_id").val(response.data.group_id);

                                $("#" + modalId).modal("toggle");
                            }
                        },
                    });
                } else {
                    $("#" + modalId).modal("toggle");
                }
            });
        };

        $("#save-add-to-group").on("click", function () {
            if ($("#update-add-to-group").valid()) {
                let vm_id = $("#add_vm_id").val();
                let group_id = $("#vm_group_id").val();
                apiService.postRequest(
                    baseUrl + "/admin/virtual-machines/group-update",
                    {
                        vm_id: vm_id,
                        group_id: group_id,
                    }
                );
            }
        });

        $("#save-remove-from-group").on("click", function () {
            if ($("#update-remove-from-group").valid()) {
                let vm_id = $("#remove_vm_id").val();
                let group_id = $("#move_group_id").val();
                apiService.postRequest(
                    baseUrl + "/admin/virtual-machines/group-update",
                    {
                        vm_id: vm_id,
                        group_id: group_id,
                    }
                );
            }
        });
    };

    let initListing = function () {
        addValidations();
        addGroup();
    };

    return {
        // public functions
        init: function () {
            initListing();
        },
    };
})();

$(document).ready(function () {
    group.init();
});
